'use client';
import { useCallback, useEffect, useState } from 'react';
import LoadingComp from 'mrCity/loading/loading.index';
import { Portal } from 'react-portal';
import { nextBrowser } from 'scripts';
import { useParams, useRouter } from 'next/navigation';

const useAppNav__ = (searchParamsSensitive = true) => {
    const [loading, setLoading] = useState(false);
    const params = useParams();
    const router = useRouter();
    const push = useCallback(
        (url: string, preventLoading = false) => {
            if (urlDiff(url)) {
                router.push(url);
                if (!preventLoading) setLoading(true);
            }
        },
        [router],
    );
    const urlDiff = (url: string) => {
        const current = new URL(nextBrowser.window?.location.href ?? '');
        const aTag = nextBrowser.document?.createElement('a');
        aTag?.setAttribute('href', url);
        const next = new URL(aTag?.href ?? '');
        const str1 = next.protocol + next.host + next.pathname + (searchParamsSensitive ? next.search : '');
        const str2 = next.protocol + current.host + current.pathname + (searchParamsSensitive ? current.search : '');
        if (str1 !== str2) return true;
        return false;
    };
    useEffect(() => {
        setLoading(false);
    }, [params]);
    return {
        push,
        context: loading ? (
            <Portal>
                <LoadingComp />
            </Portal>
        ) : null,
    };
};

export default useAppNav__;
